import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">平台特色</h2>
          <p className="text-sm text-foreground-600 mt-2">91视频网站的核心优势，为你打造极致的在线观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 md:mb-5">
                <i className={`${item.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 md:mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}